import React, {useState, useRef, useEffect} from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import APICall from '../../actions/apicall';
import cancelIcon from '../../../images/cancelIcon.png';
import Submit from '../reusable/Submit';
import '../../../css/businessinterests.scss';
import Mappings from '../../actions/mappings';
import Cookies from 'js-cookie';

function BusinessInterestSheet(props) {
    const [active, setActive] = useState([]);
    const [selectedBusiness, setSelectedBusiness] = useState({});
    const [submitText, setsubmitText] = useState('Submit');

    const interestOptions = ['own_business', 'starting_business', 'buying_business', 'selling_business', 'looking_loan', 'seeking_investment', 
            'insuring_business', 'just_curious'];
    
    let userId = Cookies.get('rs11_user_id') ?? 0;

    const handleCloseButtonClick = (action) => {
        window.dataLayer.push({'event': 'business_interests_close'});
        props.closeBusinessInterests(action, active);
        // setSelectedBusiness({});
        // setActive([]);
    }
    
    const handleBusinessInterest = () => {
        setsubmitText('Submitting...');
        let accessToken = Cookies.get('access_token') ?? null;

        let interestedOptionsArray = [];
            active.map((item, i) => (
                interestedOptionsArray.push(item)
            ))
            var interestedOptions = interestedOptionsArray.join(", ")
        
        interestedOptionsArray.map((item, index)=>{
            window.dataLayer.push({
                'event': 'select_content',
                'contentType': 'user_interest',
                'contentId': item,
                'businessId': selectedBusiness.id
            })
        });

        let data = {
            business_id: selectedBusiness.id,   
            business_interests: (interestedOptions.length > 0) ? interestedOptions : null
        }
        APICall.BusinessInterest(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                if (active.length > 0) {
                    handleCloseButtonClick('success');
                }
                else {
                    handleCloseButtonClick();
                }
            }
            else {
                handleCloseButtonClick();
            }
            setsubmitText('Submit');
        })
    }


    useEffect(() => {
        if (props.selectedBusinessData) {
            setSelectedBusiness(props.selectedBusinessData);
            setActive(props.active);
        }
    }, [props.selectedBusinessData, props.active]);


    return (
        <>
        {
            <BottomSheet open={true} onDismiss={() => handleCloseButtonClick('close')}
                header={
                    <div className="transparent-header">
                        <img className='cancel-icon' height='25px' src={cancelIcon} onClick={() => handleCloseButtonClick('close')} />
                    </div>
                }
            >
                <div className='business-interests-container'> 
                    <p>Select all that apply:</p>
                    <div className='drop-down-options customised-scrollbar-vertical'>
                        {
                            interestOptions.map((item, index) => (
                                <label class={active.includes(item) ? 'checkbox-container highlight' : 'checkbox-container'} key={`option-${index}`}>{Mappings[item]}
                                    <input type="checkbox" 
                                        checked={active.includes(item)}
                                        onChange={() => setActive(active.includes(item)
                                            ? active.filter(current => current != item)
                                            : [...active, item]
                                        )}
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            ))
                        }
                    </div>
                    <Submit actionText={submitText} callFunction={handleBusinessInterest} disable={submitText != 'Submit' && true} />
                </div>
            </BottomSheet>
        }
        </> 
    );
}

export default BusinessInterestSheet;